var path = 'app/components/common/forms/templates/div.html';
var html = "<div class=\"{{to.className}}\"><formly-transclude></formly-transclude></div>";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;


//////////////////
// WEBPACK FOOTER
// ./app/components/common/forms/templates/div.html
// module id = 401
// module chunks = 0